import type { KAAIEntry, KATemplate } from '@/lib/api/misc'

export function isManualSource(source: string): boolean {
  return source !== 'generated' && source !== 'generated.ai21'
}

export function collectManualAIs(templates: (KATemplate | null | undefined)[]): KAAIEntry[] {
  const seen = new Set<string>()
  const out: KAAIEntry[] = []
  for (const tpl of templates) {
    if (!tpl?.ai_list) continue
    for (const entry of tpl.ai_list) {
      if (!isManualSource(entry.source)) continue
      if (seen.has(entry.ai)) continue
      seen.add(entry.ai)
      out.push(entry)
    }
  }
  return out
}

export function collectAutoAIs(templates: (KATemplate | null | undefined)[]): KAAIEntry[] {
  const seen = new Set<string>()
  const out: KAAIEntry[] = []
  for (const tpl of templates) {
    if (!tpl?.ai_list) continue
    for (const entry of tpl.ai_list) {
      if (isManualSource(entry.source)) continue
      if (seen.has(entry.ai)) continue
      seen.add(entry.ai)
      out.push(entry)
    }
  }
  return out
}

export function aiInputHint(ai: string): string {
  switch (ai) {
    case '01':
    case '02':
      return '14 цифр GTIN'
    case '11':
    case '17':
      return 'DD.MM.YYYY или YYMMDD'
    case '37':
      return 'Положительное число'
    default:
      return ''
  }
}

export function autoSourceLabel(source: string): string {
  if (source === 'generated') return 'Авто (SSCC)'
  if (source === 'generated.ai21') return 'Авто (серийник AI 21)'
  return 'Авто'
}
